import {Component, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml,} from '@angular/platform-browser';
import {UserAppService} from 'src/app/services/user-app.service';

@Component({
  selector: 'app-welcome',
  template: `
    <div *ngIf="!htmlContent" class="welcome">
      <div class="hero">
        <h1>
          Embrace the Extraordinary Fusion of Chatbot Mastery and Data
          <span class="c">Wizardry!</span>
        </h1>
        <button class="btn-primary cta">
          Start your 30 Days Trial
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
        </button>
        <div class="pillars">
          <div class="pillar">
            <div class="pill-ic">
              <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-8.5 8.5 9 9 0 0 1-4-.9L3 21l1.9-5A8.4 8.4 0 0 1 4 11.5 8.4 8.4 0 0 1 12.5 3 8.4 8.4 0 0 1 21 11.5Z"/></svg>
            </div>
            <div class="pill-t">Explore Personalized Learning via Chatbot</div>
          </div>
          <div class="amp">&amp;</div>
          <div class="pillar">
            <div class="pill-ic">
              <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><rect x="4" y="11" width="4" height="7"/><rect x="10" y="6" width="4" height="12"/><rect x="16" y="9" width="4" height="9"/></svg>
            </div>
            <div class="pill-t">Data Analytics Solutions</div>
          </div>
        </div>
        <p class="blurb">
          Experience the magic of <b>Similar Deals</b> and <b>Account coaching</b>, enhanced
          by dynamic <b>Peer-to-Peer learning</b>. Explore <b>Drivers of Rep Success</b>,
          uncover the <b>Impact Analysis</b>, and conquer <b>Ramp Analysis</b> &mdash; all tailored
          for B2B Sales Reps. And many more...
        </p>
      </div>
    </div>
    <div class="iframe-container" *ngIf="htmlContent">
      <iframe [srcdoc]="htmlContent" style="width: 100%; height: 100vh; border: none;"></iframe>
    </div>
  `,
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements OnInit {
  htmlContent: SafeHtml | undefined;

  constructor(
    private userServices: UserAppService,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit(): void {
    this.userServices.getHomepage().subscribe({
      next: (response: any) => {
        const homepageHtml = response?.homepage_html_content;

        if (homepageHtml) {
          this.htmlContent =
            this.sanitizer.bypassSecurityTrustHtml(homepageHtml);
        }
      },
      error: (error: any) => {
        console.error('an error occurred while loading homepage', error);
      },
    });
  }
}
